import React, { InputHTMLAttributes } from 'react';
import styled from '@styled';
import { font_montserrat, tabletPortrait } from '../global.styles';

interface StyledInputProps extends InputHTMLAttributes<HTMLInputElement> {
  fontSize?: string;
  color?: string;
  backgroundColor?: string;
  border?: string;
  padding?: string;
  width?: string;
  borderRadius?: string;
  margin?: string;
  focusProps?: {
    outline: string;
    border: string;
    boxShadow?: string;
  };
  id: string;
  placeholder?: string;
  type: string;
  maxWidth?: string;
  maxHeight?: string;
  mobileMaxWidth?: string;
  boxShadow?: string;
}

export const StyledInput = styled('input').withConfig({
  shouldForwardProp: (prop) =>
    !['fontSize', 'backgroundColor', 'borderRadius', 'focusProps', 'maxWidth', 'maxHeight', 'mobileMaxWidth', 'boxShadow'].includes(prop),
})<StyledInputProps>`
  font-size: ${(props) => props.fontSize || '16px'};
  color: ${(props) => props.color || '#000'};
  background-color: ${(props) => props.backgroundColor || '#fff'};
  border: ${(props) => props.border || 'none'};
  padding: ${(props) => props.padding || '15px'};
  width: ${(props) => props.width || '100%'};
  max-width: ${(props) => props.maxWidth || '100%'};
  max-height: ${(props) => props.maxHeight || 'initial'};
  margin: ${(props) => props.margin || '0'};
  border-radius: ${(props) => props.borderRadius || '7px'};
  resize: none;
  font-family: ${font_montserrat};
  box-shadow: ${(props) => props.boxShadow || 'none'};

  &:focus {
    outline: ${(props) => props.focusProps?.outline || 'none'};
    border: ${(props) => props.focusProps?.border || 'none'};
    box-shadow: ${(props) => props.focusProps?.boxShadow || 'none'};
  }
  &[type='number'] {
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }

  ${tabletPortrait} {
    max-width: ${(props) => props.mobileMaxWidth || props.maxWidth || '100%'};
  }
`;
